import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PairAnalysisProvider } from "@/context/PairAnalysisContext";
import { PairsAnalysisTab } from "./components/PairsAnalysisTab";
import { DrawdownTab } from "./components/DrawdownTab";

type AnalysisTab = "pairs" | "drawdown";

export const AnalysisPage = (): React.ReactNode => {
  const [tab, setTab] = useState<AnalysisTab>("pairs");

  return (
    <div className="grid gap-6">
      <div>
        <h1 className="text-3xl font-bold">Analysis</h1>
        <p className="text-muted-foreground mt-2">Break down trading activity across pairs and time</p>
      </div>

      {/* Scoped to this page, and shared across tabs so the cache survives switching. */}
      <PairAnalysisProvider>
        <Tabs value={tab} onValueChange={(v) => setTab(v as AnalysisTab)} className="grid gap-4">
          <TabsList className="w-fit">
            <TabsTrigger value="pairs">Pairs</TabsTrigger>
            <TabsTrigger value="drawdown">Drawdown</TabsTrigger>
          </TabsList>
          <TabsContent value="pairs">
            <PairsAnalysisTab />
            </TabsContent>
          <TabsContent value="drawdown">
            <DrawdownTab />
        </TabsContent>
        </Tabs>
      </PairAnalysisProvider>
    </div>
  );
};
